import axios from 'axios'
import { z } from 'zod'
import { axiosClient } from '../../clients/axios-client'

export interface FileSectionContentResponse {
  html: string
}

const SectionHtmlResponseSchema = z.string()

async function getSectionHtml(url: string): Promise<string> {
  try {
    const { data } = await axiosClient.get<string>(url, { responseType: 'text' })
    // Validate response is a string
    return SectionHtmlResponseSchema.parse(data)
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      (error.response?.status === 404 || error.response?.status === 400)
    ) {
      // Treat missing section as "no preview available" rather than error
      return ''
    }
    throw error
  }
}

export async function getFileSectionContent(
  fileId: string,
  sectionId: string
): Promise<FileSectionContentResponse> {
  const trimmedFileId = fileId.trim()
  const trimmedSectionId = sectionId.trim()

  if (!trimmedFileId) {
    throw new Error('File ID is required')
  }

  if (!trimmedSectionId) {
    throw new Error('Section ID is required')
  }

  const encodedFileId = encodeURIComponent(trimmedFileId)
  const encodedSectionId = encodeURIComponent(trimmedSectionId)

  const html = await getSectionHtml(
    `/filepool/files/${encodedFileId}/sections/${encodedSectionId}/html`
  )

  return { html }
}
